<script setup>
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  }
})
const emit = defineEmits(['update:modelValue'])
const handleUpdate = (value) => {
  emit(
    'update:modelValue',
    value.reduce((acc, curr) => {
      if (curr.includes(',')) {
        return [...acc, ...curr.split(',').map((v) => v.trim())]
      } else {
        return [...acc, curr]
      }
    }, [])
  )
}
const handleBlur = (event) => {
  if (event.srcElement.value.length > 0) {
    handleUpdate([...props.modelValue, event.srcElement.value])
    event.srcElement.value = ''
  }
}
</script>

<template>
  <p-auto-complete
    :model-value="props.modelValue"
    multiple
    :typeahead="false"
    :dropdown="false"
    @blur="handleBlur($event)"
    @update:modelValue="handleUpdate($event)"
  ></p-auto-complete>
</template>
